var swalLandingMixin = {
	methods: {

		// Shown after the author submits the manuscript from the Select Editor page
		// NOTE: This is the confirmation of the submission if this is the 'initial-draft' submission. For the others we must update. See Tine docs.
		showSubmissionPublishedAndBlueprintCreatedPopup() {
			var self = this;

			this.$swal({
				title: this.translate('Success!'),
				width: '50rem',
				icon: 'success',
				showConfirmButton: true,
				confirmButtonText: this.translate("Go to account"),
				text: this.translate("Your manuscript has been submitted to your company of choice. You can administer your presentation and submission in your bb-flow account"),
			}).then((result) => {
				self.overflowBrowserHistory()
				location.href = "/author";
				// if (self.isBlueprintNewlyCreated) {
				// 	location.href = "/author";
				// 	// self.overwriteBlueprint();
				// } else {
				// 	self.showSaveNewBlueprintPrompt();
				// }
			});
		},

		// Used when publishing a presentation a second time, without changes.
		showSubmissionPublishedPopup() {
			var self = this;

			this.$swal({
				title: this.translate('Success!'),
				icon: 'success',
				showConfirmButton: true,
				confirmButtonText: this.translate("OK"),
				text: this.translate("You submitted your manuscript!"),
			}).then((result) => {
				self.overflowBrowserHistory()
				location.href = "/author"; // Can't use router because it's in a different file
				// self.showSaveNewBlueprintPrompt();
				// self.$router.push('/author')
			});
		},

		// Used when publishing a presentation a second time and there are changes, so we ask wether to update the Blueprint.
		showSaveNewBlueprintPrompt() {
			var self = this;

			this.$swal({
				title: this.translate("Save this version for future use?"),
				text: this.translate("Do you want to save this presentation as your “Master Manuscript” for use if you submit this manuscript to other companies in the future?"),
				footer: this.translate("If No: This version is aimed at Company") + " " + self.companyName + " " + this.translate("only – leave my Master Manuscript as it was"),
				icon: "info",
				buttonsStyling: false,
				confirmButtonText: this.translate("Use for future submissions"),
				showCancelButton: true,
				cancelButtonText: this.translate("No"),
				customClass: {
					confirmButton: "btn btn-warning",
					cancelButton: "btn btn-default"
				}
			}).then((result) => {
				if (result.value) {
					self.overwriteBlueprint();
				} else {
					self.overflowBrowserHistory()
					location.href = "/author";
					// self.$router.push('/author')
				}
			});
		},

		overwriteBlueprint() {
			var self = this;
			axios.patch('/api/author/submissions/landing/' + this.submission_id + '/overwrite-blueprint').then(function (response) {
				self.$swal({
					icon: 'success',
					showConfirmButton: false,
					timer: 1000
				}).then((result) => {
					self.overflowBrowserHistory()
					location.href = "/author";
				});
			});
		},

		overflowBrowserHistory() {
			for (let index = 0; index < 20; index++) {
				history.pushState(null, null, '/author');
			}
		}

	}
};

export { swalLandingMixin };
